<template>
  <div class="tabs-list-card">
    <a-tabs type="line">
      <a-tab-pane v-for="(tabs,index) in tabsData" :key="index" :tab="tabs.NameJ">
        <div class="list-card-categ">
          <div v-for="item in tabs.data" :key="item.id">
            <CardCategory
              :color="color"
              :bgColor="bgColor"
              :tag="item.tag"
              :imgSrc="item.imgSrc"
              :title="item.title"
              :content="item.content"
            />
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import CardCategory from '../CardCateg'

export default {
  components: {
    CardCategory
  },
  data() {
    return {
      color: '#DA291C',
      bgColor: '#F4F5F6',
      tabsData: [
        {
          NameJ: '旅',
          data: [
            {
              id: 1,
              tag: '旅',
              imgSrc: require('@/assets/images/BS_SPE_01/list.png'),
              title: 'GW海外旅行特集',
              content:
                '令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめ…'
            },
            {
              id: 2,
              tag: '旅',
              imgSrc: require('@/assets/images/BS_SPE_01/list.png'),
              title: 'GW海外旅行特集',
              content:
                '令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめ…'
            },
            {
              id: 3,
              tag: '旅',
              imgSrc: require('@/assets/images/BS_SPE_01/list.png'),
              title: 'GW海外旅行特集',
              content:
                '令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめ…'
            },
            {
              id: 4,
              tag: '旅',
              imgSrc: require('@/assets/images/BS_SPE_01/list.png'),
              title: 'GW海外旅行特集',
              content:
                '令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめ…'
            }
          ]
        },
        {
          NameJ: '食べる',
          data: [
            {
              id: 1,
              tag: '旅',
              imgSrc: require('@/assets/images/BS_SPE_01/slider.png'),
              title: 'GW海外旅行特集',
              content:
                '令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめ…'
            },
            {
              id: 2,
              tag: '旅',
              imgSrc: require('@/assets/images/BS_SPE_01/slider.png'),
              title: 'GW海外旅行特集',
              content:
                '令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめ…'
            },
            {
              id: 3,
              tag: '旅',
              imgSrc: require('@/assets/images/BS_SPE_01/slider.png'),
              title: 'GW海外旅行特集',
              content:
                '令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめ…'
            }
          ]
        },
        
        {
          NameJ: '育児・介護・健康',
          data: [
            {
              id: 1,
              tag: '旅',
              imgSrc: require('@/assets/images/BS_SPE_01/list.png'),
              title: 'GW海外旅行特集',
              content:
                '令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめ…'
            },
            {
              id: 2,
              tag: '旅',
              imgSrc: require('@/assets/images/BS_SPE_01/list.png'),
              title: 'GW海外旅行特集',
              content:
                '令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめ…'
            }
          ]
        },
        {
          NameJ: 'その他',
          data: [
            {
              id: 1,
              tag: '旅',
              imgSrc: require('@/assets/images/BS_SPE_01/list.png'),
              title: 'GW海外旅行特集',
              content:
                '令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめ…'
            },
            {
              id: 2,
              tag: '旅',
              imgSrc: require('@/assets/images/BS_SPE_01/list.png'),
              title: 'GW海外旅行特集',
              content:
                '令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめ…'
            }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
::v-deep {
  .ant-tabs-nav {
    @apply flex w-full;
  }
  .ant-tabs-nav-animated {
    @apply flex w-full;
    div {
      @apply w-full flex justify-evenly;
      @media (max-width: 768px) {
        @apply justify-between;
      }
    }
  }
  .ant-tabs-tab {
    flex: 1;
    color: #A8AAAD;
  }
  .ant-tabs-tab-active {
    color: #1f2021;
  }

  .ant-tabs-tab-active:hover {
    color: #da291c;
  }
  .ant-tabs-tab:hover {
    color: #da291c;
    @media (max-width: 768px) {
      color: #1f2021;
    }
  }
  .ant-tabs-ink-bar {
    background-color: #da291c;
    height: 4px;
  }
  .ant-tabs-tabpane, .ant-tabs-tabpane-active{
    @apply p-4;
  }
}
</style>